<script setup>
import {defineProps, defineEmits} from "vue";

//==================================================================//
//========================= Props / Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

//==================================================================//
//======================== Itens Headers ===========================//
//==================================================================//

let itensHeaders = [
    { text: '',                        value: 'expandirItem'},
    { text: 'Sequência',               value: 'sequencia'},
    { text: 'Tipo de Equipamento',     value: 'tipoDeEquipamento'},
    { text: 'Descrição',               value: 'descricao'},
    { text: 'Prazo Entrega',           value: 'dataPrazoEntregaFormatada'},
    { text: 'Quantidade',              value: 'quantidade'},
    { text: 'Preço Unitário',          value: 'precoUnitario'},
    { text: 'Preço Total',             value: 'precoTotal'},
    { text: 'Base ICMS/ISS',           value: 'valorBaseICMS_ISS'},
    { text: '%ICMS',                   value: 'porcentagemICMS'},
    { text: 'Valor ICMS',              value: 'valorICMS'},
    { text: '%IPI',                    value: 'porcentagemIPI'},
    { text: 'Valor IPI',               value: 'valorIPI'},
    { text: '%ISS',                    value: 'porcentagemISS'},
    { text: 'Valor ISS',               value: 'valorISS'},
]

</script>

<template>

    <div class="c-table__header">

        <div class="c-header__cell" v-for="itemHeader in itensHeaders"
            :key="itemHeader.value"
        >

            <div class="c-cell c-cell__text">

                {{itemHeader.text}}

            </div>
            
        </div>

    </div>

</template>

<style scoped>

.c-table__header{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    color: rgba(0, 0, 0, 0.6);
    font-size: 0.75rem;
}

.c-header__cell{
    align-content: center;
    padding: 14px 16px;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-weight: 700;
    background-color: #230bc1;
    color: #ffffff;
}

.c-checkbox{
    padding: 0px;
    margin: 0px;
}

.c-checkbox >>> .v-icon{
    font-size: 26px;
}

.c-checkbox >>> .mdi-checkbox-blank-outline::before{
    color: white;
}

.c-checkbox >>> .mdi-checkbox-marked::before{
    color: white;
}

.c-checkbox >>> .v-input--selection-controls__input{
    margin: 0px;
}

.c-checkbox >>> .v-input__control{
    flex-grow: 0;
    flex-wrap: nowrap;
    min-width: auto;
    width: auto;
}

</style>